import { render, staticRenderFns } from "./sourceReview.vue?vue&type=template&id=1e84e7ba"
import script from "./sourceReview.vue?vue&type=script&lang=js"
export * from "./sourceReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports